import type { SVGProps } from "react";

export function PropertyBadgeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={14}
      height={14}
      fill="none"
      viewBox="0 0 14 14"
      {...props}>
      <path
        fill={props.fill || "#333"}
        d="M-1 .5A1.5 1.5 0 0 1 1.915 0H13.5a1.5 1.5 0 0 1 .496 2.916C14 2.944 14 2.972 14 3v7a3 3 0 0 1-3 3H4a2.99 2.99 0 0 1-2-.764v2.014a.75.75 0 0 1-.75.75h-1.5a.75.75 0 0 1-.75-.75V.5ZM13 10V3H2v7a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2ZM1 2h12.5a.5.5 0 0 0 0-1H1V.5a.5.5 0 0 0-1 0V14h1V2Zm3.5 4.955v2.55a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-2.55a1 1 0 0 0-.336-.748l-2.332-2.07a.5.5 0 0 0-.664 0l-2.332 2.07a1 1 0 0 0-.336.748Z"
      />
    </svg>
  );
}
